import { DateTime } from "luxon";

export class EntityApiKey {
    constructor(
        public readonly id: number,
        public readonly entityId: number,
        public readonly name: string,
        public readonly prefix: string,
        public readonly scopes: string[],
        public readonly isActive: boolean,
        public readonly created: DateTime,
        public readonly modified: DateTime,
    ) {}
}

export class EntityApiKeys {
    constructor(
        public readonly apiKeys: EntityApiKey[],
        public readonly count: number,
    ) {}
}

export class CreatedEntityApiKey {
    constructor(
        public readonly apiKey: EntityApiKey,
        public readonly plaintextKey: string,
    ) {}
}
